import { VariantData } from '@basehub/data/replicache/index'
import * as React from 'react'
import { VariantPills } from '../../(editor)/explore/components/blocks/variant-pills'
import { clsx } from 'clsx'
import { BlockIcon } from '~/components/block-icon'

export type OverridesDiffWrapperProps<T> = {
  children: React.ReactNode | ((props: T) => React.ReactNode)
  overrides: T[]
}

export const OverridesDiffWrapper = <
  T extends { overrideKey: string | VariantData[]; className?: string },
>({
  children: Comp,
  overrides,
}: OverridesDiffWrapperProps<T>) => (
  <div className="bg-dark-bg border border-dark-border-solid border-dashed rounded-b-lg rounded-tr-lg px-3 pb-4 pt-[1.375rem] relative gap-y-3 grid mt-[2.375rem]">
    <div className="px-3 rounded-t h-[1.625rem] absolute -left-px -top-[1.5625rem] flex items-center font-medium text-xs text-dark-muted gap-x-1.5 bg-dark-bg leading-normal border-dashed border-dark-border-solid border border-b-0">
      <BlockIcon
        block={{ type: 'variant-set' }}
        iconProps={{ className: 'size-4' }}
      />
      <span>Variants</span>
    </div>
    {typeof Comp === 'function'
      ? overrides.map((i) => (
          <React.Fragment key={i.overrideKey + '-frag'}>
            <div className="flex gap-2">
              <VariantPills variants={i.overrideKey} />
            </div>
            <Comp {...i} className={clsx('last:!mb-0 mb-3', i.className)} />
          </React.Fragment>
        ))
      : Comp}
  </div>
)
